const PortalStorage = require("./PortalStorage");
const PortalEvent = require("./PortalEvent");

module.exports = class PortalAuthenticator {

    constructor(opts={}) {

    }

    initiateLogin(username, password) {
        window.app.startSession(window.app.lang, username, password).then((ret) => {
            if (ret && ret.token && ret.user && ret.user.user) {
                window.app.setCookies(ret);
                window.location.reload();
            }
        }, (ret) => {
            PortalStorage.clearOutCookie();
            $('#loginModal').modal('show');
            $("#loginErrorText").text("Login Failed. Incorrect Username or Password.");
            $("#loginErrorText").removeClass("hidden");
        });
    }

    registerUser(name, email) {
        //start spinner
        PortalEvent.emit("showSpinner");
        return new Promise((resolve, reject) => {
            
            let url_string = window.location.protocol + window.location.host + "/easydb-record-view/user_register.php";
            fetch(new URL(url_string), {
                method: "POST",
                body: JSON.stringify({
                    name: name,
                    email: email
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then((resp) => (resp.ok ? resp.json() : resp.text().then(reject)))
            .then((data) => {
                PortalEvent.emit("hideSpinner"); // Hide spinner
                if (data.status) {
                    return resolve(data);
                } else {
                    return reject(data);
                }
            })
            .catch((error) => {
                PortalEvent.emit("hideSpinner"); // Hide spinner
                return reject(error);
            });
            
        });
    }

}


//////////////////
// WEBPACK FOOTER
// ./js/PortalAuthenticator.js
// module id = 14
// module chunks = 0